import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import updateZipFormFromData from 'core/controllers/zipSearchHandler'
import { IS_DENTAL_AND_VISION } from 'core/constants/environment'
import getPriceRange from 'core/services/getPriceRange'
import store from 'utils/store/withMiddleware'
import agentStore from 'utils/store/simple'
import { sendLandingViewEvent } from 'core/services/email/blueshift/implementations/landing'

function initDOM({ hcStorage }) {
  // Setup GTM and add userId to dataLayer
  window.dataLayerPushVariable({
    user_id: hcStorage.healthcareUserId
  })
  // window.hc.smartlySDK is used safely because initPage() was executed before
  const smartlySDK = window.hc.smartlySDK
  if (smartlySDK) {
    smartlySDK.track('ph_display_landing')
    smartlySDK.publish()
  }

  sendLandingViewEvent()

  updateZipFormFromData({ hcStorage })

  let chain = Promise.resolve()

  if (hcStorage.location.state_acronym && !IS_DENTAL_AND_VISION) {
    chain = chain
      .then(() => getPriceRange(hcStorage.location.state_acronym))
      .then(priceRange => {
        store.update({ priceRange })
      })
  }

  chain.then(() => agentStore.getState()).then(() => executeWhenFinishToRender(hcStorage))
}

export default initDOM
